import { FormControl, FormLabel, HStack, useRadioGroup, Grid, Text, Select } from '@chakra-ui/react'
import React from 'react'
import { SizePickerButton } from './SizePickerButton'
import { useSelector } from 'react-redux'

export const AttributePicker = (props) => {
  const { options, register, handleChange, rootProps, hideLabel, label, ...rest } = props;
  const { getRadioProps, getRootProps, value } = useRadioGroup(rest);
  const baseurl = useSelector(state => state.baseurl.baseURL);
  
  // Normalize URLs by removing trailing slashes for consistent comparison
  const normalizeUrl = (url) => url.replace(/\/+$/, '');
  const isKanishqOptical = normalizeUrl(baseurl) == normalizeUrl("https://kanishqoptical.ondemandcrm.co");

  return (
    <Select 
      pointerEvents={options.code_gen == 1 ? "none" : ""} 
      size='sm'
      placeholder={options.Is_Required > 0 ? `Select option` : ''}
      defaultValue={options.ValueID}
      {...register(`Attr[][${options.ID}]`)}  
      onChange={handleChange}
      isDisabled={isKanishqOptical ? !!options.ValueID : false}
      className={isKanishqOptical ? "attribute-picker-select" : ""}
    >
      {Object.values(options.Masters).map((option_sel) => (
        <option 
          key={option_sel.ID} 
          value={option_sel.ID}
          className={isKanishqOptical ? "font-bold opacity-100" : ""}
        >
          {option_sel.N}
        </option>
      ))}
    </Select>
  );
};